import { Link } from "react-router-dom";
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";

import { SignOutButton, useAuth } from '../../auth';

import brandImg from '../../assets/images/short-name-transparent.png'
import { BootstrapIcon } from "../BootstrapIcon";
//import { menuItems } from "./Navigation";
import * as choiceApi from '../../api/choice';

import './Navigation.scss';

function NavIcon({
    to,
    eventKey,
    icon,
    label,
}) {
    return(
        <Nav.Link to={to} as={Link} eventKey={eventKey}>
            <div className="nav-icon-group">
                <div className="nav-icon"><BootstrapIcon icon={icon} /></div>
                <div className="nav-label">{label}</div>
            </div>
        </Nav.Link>
    );
}

export function Navigation(props) {
    const { user } = useAuth();

    const authUserButtons = [
        <NavIcon eventKey={11} key="directions" to='/member/directions' icon='geo-alt' label='Directions' />,
        <NavIcon eventKey={11} key="calendar" to='/member/reservation' icon='calendar-heart' label='Reservations' />,
        <NavIcon eventKey={12} key="settings" to='/member/setting/password' icon='gear' label='Settings' />,
        <div key="sign-out" className="align-self-center"><SignOutButton key="sign-out" /></div>
    ];

    const unAuthUserButtons = [
        <Nav.Link eventKey={10} key="sign-in" to='#signin' as={Link} className="nav-link"><Button variant="outline-primary">Sign&nbsp;In</Button></Nav.Link>,
        <Nav.Link eventKey={20} key="join-now" to='/join' as={Link} className="nav-link"><Button variant="primary">Join&nbsp;Now</Button></Nav.Link>
    ]

    const buttons = user ? authUserButtons : unAuthUserButtons;

    const authSubNavButtons = [
        <div key="sign-out" className="align-self-center"><SignOutButton key="sign-out" /></div>
    ]

    const unAuthSubNavButtons = [
        <Nav.Link eventKey={10} key="sign-in" to='#signin' as={Link} className="nav-link"><Button variant="outline-primary">Sign&nbsp;In</Button></Nav.Link>,
        <Nav.Link eventKey={20} key="join-now" to='/join' as={Link} className="nav-link"><Button variant="primary">Join&nbsp;Now</Button></Nav.Link>
    ]

    const subNavButtons = user ? authSubNavButtons : unAuthSubNavButtons;

    return (
        <Navbar expand="lg" bg="light" variant="light" collapseOnSelect>
            <Container fluid>
                <div className="banner-bar">
                    <Navbar.Toggle />

                    <Navbar.Brand className="d-flex" href="/">
                        <img src={brandImg} alt="" />
                    </Navbar.Brand>

                    <div className="sub-navbar">
                        {subNavButtons}
                    </div>
                </div>

                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto icon-nav" bg="light" navbar>
                        <NavIcon eventKey={1} to='/' icon='house' label='Home' />
                        <NavIcon eventKey={2} to='/about' icon='question-circle' label='About' />
                        <NavIcon eventKey={3} to='/memberships' icon='person-vcard' label='Memberships' />
                        <NavIcon eventKey={4} to='/event-calendar' icon='calendar3' label='Events' />
                        <NavIcon eventKey={5} to='/policy' icon='file-earmark-medical' label='Policies' />
                        <NavIcon eventKey={6} to='/faq' icon='chat-quote' label='F.A.Q.' />
                        <NavIcon eventKey={7} to='/contact-us' icon='envelope' label='Contact' />
                    </Nav>
                    <Nav className="ms-auto" bg="light" navbar>
                        <div className="member-buttons">
                            { buttons }
                        </div>
                    </Nav>
                </Navbar.Collapse>

            </Container>
        </Navbar>
    );
}


export function UserInfoBar() {
    const { user } = useAuth();

    //
    // Nothing to display if no one has logged in yet
    //
    console.log(user);
    if (!user) {
        return null;
    }

    const names = user.members.map((x) => x.nickname).join(' & ');

    const validOrgs = user.organizations
        .filter((x) => x.id !== choiceApi.ORG_ID_ANY)
        .filter((x) => x.expires !== null);

    let expirationMsg = " does not have any dues on record.";

    if (validOrgs?.length>0) {
        const memberships = validOrgs.map((x) => `${new Date(x.expires).toLocaleDateString()} (${x.name})`)
        expirationMsg = `expires ${memberships.join(' & ') }`
    }

    return(
        <div className="user-info-bar bg-light text-dark">
            Welcome back {names}. Your {user.level} {user.type} membership {expirationMsg}
        </div>
    )
}
